import { useEffect, useState } from "react";
import { FileInput } from "./FileInput";
import { VisorAnyDocument } from "../../documents/VisorAnyDocument";
import { Modal } from "./Modal";
import { FileService } from "../../../core/services/FileService";
import { Alert } from "./Alert";

interface Props {
    _docList: any[];
    onChange: Function;
    onlyView?: boolean;
}

interface DocumentLoad {
    MediaContext: string;
    Media: string;
    Name: string;
    TypeName: string;
}

export const AtachDocument = ({ _docList, onChange, onlyView }: Props) => {

    const [docList, setDocList] = useState<DocumentLoad[]>([]);
    const fileService = new FileService();

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    useEffect(() => {
        if (_docList.length > 0) {
            setDocList(_docList);
        }
    }, [_docList])


    useEffect(() => {
        if (onChange) {
            onChange(docList)
        }
    }, [docList])

    return (
        <>
            <div className="row">
                {!onlyView &&
                    <div className="col-md-12">
                        <FileInput onCreate={({ Media, MediaContext, Name, TypeName }) => {
                            let x = []
                            x.push({ Media: Media, MediaContext: MediaContext, Name: Name, TypeName: TypeName });
                            setDocList([...docList, ...x]);
                        }} />
                    </div>
                }
                {docList.length === 0 ? (
                    <div className="col-md-12">
                        <Alert clase="info text-center" >Sin documentos visibles</Alert>
                    </div>
                ) : (
                    <div className="col-md-12">
                        <hr className="mt-2" />
                        <label>Documentos cargados</label>
                        <div className="list-group " style={{ maxHeight: "52vh", overflow: "auto" }}>
                            {docList.map((item: any, index: number) => (
                                <div key={index} className="list-group-item d-flex justify-content-between align-items-center pointer " onClick={() => {
                                    setModal({ ...modal, view: true, name: `Documento: ${item.Name}`, media: item.Media, type: item.TypeName, mediaContext: item.MediaContext });
                                }}
                                >
                                    <span style={{ width: "80%", overflow: "hidden", textWrap: "nowrap" }}>
                                        <i className="ri-article-line fs-2 align-middle me-2 cursor"></i>
                                        {index + 1} - {item.Name}
                                    </span>
                                    {!onlyView &&
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setDocList(prev => prev.filter((_, i) => i !== index));
                                            }}
                                        >
                                            <i className="ri-close-line"></i>
                                        </button>
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            <Modal modal={modal} updateModal={setModal}>
                <VisorAnyDocument url={fileService.getUrlFile(modal.mediaContext, modal.media)} type={modal.type} />
            </Modal>

        </>
    )
}